import { Box, Text, TextProps } from '@rbilabs/universal-components';

export const ProductInformationContainer = Box.withConfig({
  accessible: true,
  focusable: true,
  paddingX: { base: '$4', md: '$0' },
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const ProductInformationTitle = Text.withConfig({
  variant: 'headerFour',
  fontSize: '16px',
  marginY: '$4',
});

export const ProductInformationTextProps: TextProps = {
  fontSize: {
    base: 'xs',
    md: 'sm',
  },
};
